import * as React from 'react'
import ReactDOM from 'react-dom/client'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import App from './App'
import { QueryClient, QueryClientProvider } from 'react-query'
import './i18n'
import theme from './config/theme'
import './index.css'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: (failureCount, error: any) => {
        // Ne pas retry sur erreurs 400/401/403 (auth issues)
        if (error?.response?.status && [400, 401, 403].includes(error.response.status)) {
          return false
        }
        // Retry max 1 fois pour autres erreurs
        return failureCount < 1
      },
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000, // Cache 10 minutes au lieu de 0
      useErrorBoundary: (error: any) => {
        // Utiliser ErrorBoundary seulement pour erreurs 5xx
        return error?.response?.status >= 500
      },
    },
  },
})
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
